module.exports = __webpack_public_path__ + "img/mon_24.252bac91.png";